import React, { useEffect, useRef, useState } from 'react';


import 'fonts/font.css'; // Global font styles


// Assets
// import videoSource from 'pages_centennial/video/0901-01-banner.mp4';
import videoSource from 'pages_centennial/video/2026_01_15.mp4';




// import logoLeft from './estes_crop.png';
// import logoRight from './aiaa_white.png';

import logoRight from './logo_set_2.png';
import logoLeft from './aiaa_white.png';

const PlayOnceVideo = () => {
  const videoRef = useRef(null);

  // Statuses: 'loading' | 'ready' | 'playing' | 'hanging' | 'finished'
  const [status, setStatus] = useState('loading');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  // 1. Handle Responsive Layout
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1000);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 2. State Machine Logic
  useEffect(() => {
    let timer;

    if (status === 'ready') {
      // Wait 2 seconds while showing logos, then fade to video
      timer = setTimeout(() => {
        setStatus('playing');
        videoRef.current?.play();
      }, 2000);
    }

    if (status === 'hanging') {
      // Hang on the last frame for 3 seconds before fading logos back in
      timer = setTimeout(() => {
        setStatus('finished');
      }, 500);
    }

    return () => clearTimeout(timer);
  }, [status]);

  const handleCanPlay = () => {
    if (status === 'loading') setStatus('ready');
  };

  const handleEnded = () => {
    setStatus('hanging');
  };

  // 3. Derived UI States
  // Logos are visible during loading/ready and once the sequence is finished
  const showContent = status === 'loading' || status === 'ready' || status === 'finished';
  // Video is visible while playing and while hanging on the last frame
  const showVideo = status === 'playing' || status === 'hanging';

  return (
    <div className="banner-system-container" style={{
      position: 'relative',
      marginTop: '0rem',
      width: '100%',
      minHeight: isMobile ? 'auto' : '15rem',
      backgroundColor: 'rgba(0,0,0,0.8)', // Matching your dark theme
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40vh',
      maxHeight: '40vh',
    }}>

      {/* LAYER 1: BRANDING CONTENT */}
      <div className="branding-layer" style={{
        width: '100%',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: isMobile ? '2rem 5%' : '0 5%',
        gap: isMobile ? '1.5rem' : '0',
        transition: 'opacity 1.5s ease-in-out',
        opacity: showContent ? 1 : 0,
        zIndex: 1
      }}>
        {/* Left Logo */}
        <div style={{ flex: '1', display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}>
          <img
            src={logoLeft}
            alt="Client Logo"
            style={{ 

              margin: '0rem',
              // marginTop: '0rem',
              // marginBottom: '0rem',
              // marginRight: '1rem',
              // marginLeft: '1rem',
              
              maxWidth: isMobile ? '15rem' : '20rem', width: 'auto', objectFit: 'contain'
             }}
          />
        </div>

        {/* Center Caption */}
        <div style={{ flex: '2', textAlign: 'center', color: '#ddd' }}>
          <p style={{

            margin: '0rem',
            // marginTop: '0rem',
            // marginBottom: '0rem',
            // marginRight: '1rem',
            // marginLeft: '1rem',

            fontSize: isMobile ? '1.1rem' : '1.7rem',
            // fontWeight: 'bold',
            textTransform: 'uppercase',
            // fontFamily: 'orbitron_medium',
            fontFamily: 'orbitron_regular'
          }}>
            THANKS TO OUR SPONSORS
          </p>
          {/* <p style={{
            margin: '0 0 0 0', fontSize: isMobile ? '0.9rem' : '1.1rem',
            fontFamily: 'roboto_regular',
          }}>
            Estes Industries and the American Institute of Aeronautics and Astronautics
          </p> */}
        </div>

        {/* Right Logo */}
        <div style={{ 
          
          margin: '0rem',
          // marginTop: '0rem',
          // marginBottom: '0rem',
          // marginRight: '1rem',
          // marginLeft: '1rem',

          flex: '1', display: 'flex', justifyContent: isMobile ? 'center' : 'flex-end' 
          }}>

          <img
            src={logoRight}
            alt="Project Logo"
            style={{ maxWidth: isMobile ? '20rem' : '20rem', width: 'auto', objectFit: 'contain' }}
          />
        </div>
      </div>

      {/* LAYER 2: VIDEO OVERLAY */}
      {/* We keep the video in DOM until the very end to ensure smooth fade out */}
      <video
        ref={videoRef}
        onCanPlayThrough={handleCanPlay}
        onEnded={handleEnded}
        muted
        playsInline


        style={{
          position: 'absolute',

          //original 
          //top: 0,
          //left: 0,

          //transform
          // Pin to the center of the parent
          top: '50%',
          left: '50%',
          // Offset by half its own width/height to perfectly center
          transform: 'translate(-50%, -50%)',


          maxHeight: '40vh',
          maxWidth: '100%',
          objectFit: 'cover',
          transition: 'opacity 1.5s ease-in-out',
          opacity: showVideo ? 1 : 0,
          zIndex: 10,
          pointerEvents: 'none',

          border: 'none',
        }}


        // FIXES:
        // crossOrigin="anonymous"

        autoPlay  // Add this
        preload="auto" // Ensure this is here



      >
        <source src={videoSource} type="video/mp4" />
      </video>

    </div>
  );
};

export default PlayOnceVideo;















// <source src="/static/media/2026_01_15.8226580e579668c2faf8.mp4" type="video/mp4">

// https://firstlaunchcentennial.org/static/media/2026_01_15.8226580e579668c2faf8.mp4

// curl -I -H "Range: bytes=0-1" https://firstlaunchcentennial.org/static/media/2026_01_15.8226580e579668c2faf8.mp4






